import React, { useState } from "react";
import { ArrowUpRight } from "lucide-react";
import Reveal from "./Reveal";
import { CATEGORIES } from "../data/data";

export function Categories() {
  const [pressed, setPressed] = useState(null);

  return (
    <section id="categories" className="py-24 px-6 md:px-10">
      <div className="max-w-7xl mx-auto">
        <Reveal>
          <p className="uppercase tracking-widest text-xs mb-3" style={{ fontFamily: "'JetBrains Mono', monospace", color: "#1E9AFF" }}>
            Collections
          </p>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 style={{ fontFamily: "Fraunces, serif" }} className="text-4xl md:text-5xl mb-14">
            Shop by category
          </h2>
        </Reveal>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {CATEGORIES.map((c, i) => (
            <Reveal key={c.name} delay={i * 0.08}>
              <a
                href="#shop"
                onMouseDown={() => setPressed(c.name)}
                onMouseUp={() => setPressed(null)}
                onMouseLeave={() => setPressed(null)}
                className="category-card group relative flex items-end h-64 rounded-2xl overflow-hidden p-6"
                style={{
                  transform: pressed === c.name ? "scale(0.97)" : "scale(1)",
                  transition: "transform 0.18s ease",
                }}
              >
                <img
                  src={c.image}
                  alt={c.name}
                  loading="lazy"
                  className="absolute inset-0 w-full h-full transition-transform duration-500 group-hover:scale-110"
                  style={{ objectFit: "cover" }}
                />
                <div
                  className="absolute inset-0"
                  style={{ background: "linear-gradient(180deg, rgba(11,13,16,0.15) 0%, rgba(11,13,16,0.85) 100%)" }}
                ></div>
                <div className="absolute inset-0 transition-colors duration-300 group-hover:bg-black/10"></div>
                <div className="relative flex items-center justify-between w-full">
                  <span className="text-white text-xl" style={{ fontFamily: "Fraunces, serif" }}>{c.name}</span>
                  <span className="w-10 h-10 rounded-full flex items-center justify-center transition-all duration-300 group-hover:translate-x-1 group-hover:rotate-45" style={{ background: "rgba(255,255,255,0.18)" }}>
                    <ArrowUpRight size={18} className="text-white" />
                  </span>
                </div>
              </a>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Categories;
